const appSettings = {
  baseURL: process.env.VUE_APP_API_HOST,
  NODE_ENV: process.env.NODE_ENV,
  VUE_APP_NAME: process.env.VUE_APP_NAME,
  VUE_APP_VERSION: process.env.VUE_APP_VERSION,
};

export const { baseURL, NODE_ENV, VUE_APP_NAME, VUE_APP_VERSION } = appSettings;
